import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem } from "../../../utils/config";
import { downloadExcel } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import NotFound from "../Common/NotFound";
import customSelectStyles from "../SelectStyle";

const { RangePicker } = DatePicker;

const RankLog = (props) => {
    const dispatch = useDispatch();
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [productPerpage, setProductPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getList(event.selected + 1)
    }
    const timerRef = useRef(null);

    useEffect(() => {
        if (firstLoad) {
            getList();
            setFirstLoad(false);
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            setPageNumber(1);
            getList(1);
        }
    }, [email, productPerpage, from, to, props.lang]);

    useEffect(() => {
        getList();
    }, [pageNumber, props.lang, productPerpage, email, from, to]);

    const getList = (page = pageNumber) => {
        setLoading(true);
        let url = api.get_customer_rank_logs + `?page=${page}`;

        if (from && to) {
            url += `&date_start=${from}&date_end=${to}`
        }
        if (productPerpage) {
            url += `&limit=${productPerpage}`
        }
        if (email) {
            url += `&email=${email}`
        }
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                if (responseJson.status === "success") {
                    setResult(responseJson.data.results);
                    var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                    setPageCount(pageCount);
                    setTotalResultCount(responseJson.data.total_results)
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log("error", responseJson.message);
                }

            }).catch(error => {
                console.error("error", error);
            });
    }

    const handleTimeChange = (e) => {
        const formattedFromDate = e ? dayjs(e[0]).format("YYYY-MM-DD") : '';
        const formattedToDate = e ? dayjs(e[1]).format("YYYY-MM-DD") : '';
        setFrom(formattedFromDate);
        setTo(formattedToDate);
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(item => {
            let formattedData = {
                "Process Date": item.date_added ? item.date_added : '',
                "Email": item.email ? item.email : '',
                "Name": item.full_name ? item.full_name : item.nick_name,
                "Type": item.type ? item.type : "-",
                "Original Rank": item.current_rank_name ? item.current_rank_name : '',
                "New Rank": item.new_rank_name ? item.new_rank_name : '-',
                "MT5 balance": item.mt5_balance ? Number(item.mt5_balance).toLocaleString('en-US') : 0,
                "Personal Sales": item.personal_sales ? Number(item.personal_sales).toLocaleString('en-US') : 0,
                "Group Sales": item.group_sales ? Number(item.group_sales).toLocaleString('en-US') : 0,
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_customer_rank_logs + `?page=${pageCount}&order_by=DESC&limit=${exportPageSize}`;

                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (email) {
                    url += `&email=${email}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'rank_log')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });


            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Enter Member Email")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>

                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <RangePicker
                                            className="w-100 mt-3 mt-md-0 input-transparent"
                                            placeholder={[
                                                translate(props.lang, "From"),
                                                translate(props.lang, "To"),
                                            ]}
                                            onChange={(e) => handleTimeChange(e)}
                                        />
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Result Per Page")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerPage(e.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => exportExcel()} disabled={loadingExcel}>
                                            <span className={`btnText`}>{loadingExcel ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Download Excel")}</span>
                                        </button>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Process Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Rank Type")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Original Rank")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "New Rank")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Balance")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Personal Sales")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Group Sales")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={9}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.date_added ? item.date_added : ''}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.email ? item.email : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.full_name ? item.full_name : item.nick_name}</td>
                                                        <td className={`font-weight-500 font-16 text-center text-capitalize`}>{item.type ? translate(props.lang, item.type) : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.current_rank_name ? item.current_rank_name : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.new_rank_name ? item.new_rank_name : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.mt5_balance ? Number(item.mt5_balance).toLocaleString('en-US') : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.personal_sales ? Number(item.personal_sales).toLocaleString('en-US') : 0} </td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.group_sales ? Number(item.group_sales).toLocaleString('en-US') : 0} </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={9}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(RankLog);